@if (regionData?.result$ | async; as result) {
    @if (result.value?.data; as region) {
        <div class="search-container-details">
            <div class="tab-title-icon">
                <cll-icon class="tab-icon" type="outlined">explore</cll-icon>
                <div class="accordion-sub-title-accordion">
                    <span class="detail-table-title">Zones</span>
                    <span class="detail-table-sub-title">Zones associated with this region</span>
                </div>
            </div>
            <div>
                @if (region.status) {
                    @if ((user()?.permissions?.permissions ?? []).includes('region.create')) {
                        <button cll-icon-button cllSuffix (click)="addZone()">
                            <cll-icon>add</cll-icon>
                        </button>
                    }
                }
            </div>
        </div>
        <div class="tabs-table-container">
            <table class="cll-table">
                <thead>
                <tr>
                    <th>Zone</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    @if (region?.zones; as zones) {
                        @if (zones.length > 0) {
                            @for (zone of zones; track zone.id) {

                                <tr>
                                    <td>{{ zone.name }}</td>
                                    <td>{{ zone.description }}</td>
                                    <td>
                                        @if (zone.status) {
                                            <cll-badge colour="success">Active</cll-badge>
                                        } @else {
                                            <cll-badge colour="error">Inactive</cll-badge>
                                        }
                                    </td>
                                    <td class="align-right">
                                        @if ((user()?.permissions?.permissions ?? []).includes('region.update')) {
                                            <button cll-icon-button
                                                    [cllMenuTriggerFor]="menu"
                                                    (click)="$event.stopPropagation()">
                                                <cll-icon>more_vert</cll-icon>
                                            </button>

                                            <ng-template #menu>
                                                <cll-menu>
                                                    @if (region.status) {
                                                        @if (zone.status) {
                                                            <button cllMenuItem (click)="editZone(zone)">
                                                                <cll-icon type="outlined">edit</cll-icon>
                                                                Edit
                                                            </button>
                                                            <button cllMenuItem (click)="changeStatus(zone, false)">
                                                                <cll-icon type="outlined">toggle_off</cll-icon>
                                                                Mark as inactive
                                                            </button>
                                                        } @else {
                                                            <button cllMenuItem (click)="changeStatus(zone, true)">
                                                                <cll-icon type="outlined">toggle_on</cll-icon>
                                                                Mark as active
                                                            </button>
                                                        }
                                                    }
                                                </cll-menu>
                                            </ng-template>
                                        }
                                    </td>
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td colspan="4" class="no-data-row">
                                    <div class="no-data-wrapper-tabs">
                                        No Zones found.
                                    </div>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
    }
}
